// extracted by mini-css-extract-plugin
export default {"card":"PZ-z","carouselContainer":"QZ-z","carouselContent":"RZ-z"};